// extracted by mini-css-extract-plugin
export default {"headerContainer":"header_headerContainer__AbCNU","backIcon":"header_backIcon__RGYBD","headerText":"header_headerText__uUUfS","ui-typo":"header_ui-typo__kDpqs"};